import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type PayGatePaymentModuleSpecsFragment } from '../../../../api/fragments/PayGatePaymentModuleSpecs';
import PayGatePaymentSettingActions from './PayGatePaymentSettingActions';

export type PayGatePaymentSettingsTableProps = {
    module: PayGatePaymentModuleSpecsFragment;
};

export type PaymentSettingSpecs = PayGatePaymentModuleSpecsFragment['paymentSettings'][number];

const PayGatePaymentSettingsTable = ({ module }: PayGatePaymentSettingsTableProps) => {
    const { t } = useTranslation(['payGatePaymentModuleDetails']);

    const renderActions = useCallback(
        (record: PaymentSettingSpecs) => <PayGatePaymentSettingActions module={module} paymentSetting={record} />,
        [module]
    );

    return (
        <Table dataSource={module.paymentSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('paygatePaymentModuleDetails:paymentSettingsTable.columns.displayName')}
            />
            <Table.Column
                key="currency"
                dataIndex="currency"
                title={t('paygatePaymentModuleDetails:paymentSettingsTable.columns.currency')}
            />
            <Table.Column
                key="amount"
                dataIndex="amount"
                title={t('paygatePaymentModuleDetails:paymentSettingsTable.columns.amount')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('paygatePaymentModuleDetails:paymentSettingsTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default PayGatePaymentSettingsTable;
